export const GET_FAQ_LIST_QUERY = (category: number, keyword: string, page: number): string =>
    `
    query {
        getFAQs(seq: 0, category: ${category}, keyword: "${keyword}", page: ${page}) {
            items {
                seq
                category
                title
            }
            currentPage
            totalPage
            totalItems
        }
    }
    `;

export const GET_FAQ_DETAIL_QUERY = (seq: number): string =>
    `
    query {
        getFAQs(seq: ${seq}, category: 0, keyword: "", page: 0) {
            items {
                category
                title
                content
            }
        }
    }
    `;